/**
 * PM-Bugreport (2026-09-09): "Die 3 Cards sind nicht mehr da, wenn man die Variante ändert."
 *
 * Root cause: Impact's own `<product-gallery>` custom element (`assets/theme.js`, `_onVariantChanged`)
 * listens for the `variant:change` event dispatched on the product form and, when the new variant's
 * `featured_media` differs from the previous one, calls `carousel.select(newPosition)` — which purely
 * toggles the `is-selected` class client-side onto whichever `.product-gallery__media` slide matches that
 * media position. It never re-renders the gallery's HTML from the server for this interaction (that's why
 * the former `?view=` fetch patch in `layout/theme.liquid` (removed, templates are assigned in Admin) only covered the AJAX *section*
 * re-render used for price/variant-picker sync, does not help here — the gallery image switch is a
 * separate, purely client-side code path).
 *
 * Our 3 benefit tiles (`.up2-gallery-tiles`, rendered once at SSR time — `snippets/up2-gallery-tiles.liquid`
 * via `snippets/product-gallery.liquid` — inside whichever `.product-gallery__media` slide matched
 * `default_media` for the INITIAL page load) therefore stayed on that original slide even after switching
 * to a variant whose default image is a different slide: `is-selected` moved to the new slide, but the
 * tiles (and the `up2-pdp-hero-slide` square/flex layout, `assets/up2-home.css`) stayed behind on the now-
 * inactive one, so they visually disappeared.
 *
 * Fix: mirror Impact's own listener exactly (same event, same `featured_media`-changed check, same
 * position math). When the variant's featured media actually changes, move the `.up2-gallery-tiles`
 * element (and the `up2-pdp-hero-slide` class) into the slide now matching that new position — the same
 * slide Impact's own `carousel.select()` is about to make `is-selected`.
 *
 * Deliberately scoped to `variant:change` only, not every gallery navigation: manually clicking a
 * thumbnail/swiping the carousel does not fire `variant:change`, so it can never relocate the tiles. That
 * matches the product requirement ("only the current variant's default image gets the 3 cards"), not
 * "whichever slide the visitor happens to be looking at right now".
 */
(function () {
  'use strict';

  function initGalleryTiles(gallery) {
    var tiles = gallery.querySelector('.up2-gallery-tiles');
    if (!tiles) return;

    var formId = gallery.getAttribute('form');
    var form = formId ? document.forms[formId] : null;
    if (!form) return;

    form.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant;
      if (!variant) return;

      var previousVariant = detail.previousVariant;
      var media = variant.featured_media;

      var changed = false;
      if (previousVariant === null || previousVariant === undefined) {
        changed = !!media;
      } else if (media && previousVariant.featured_media && previousVariant.featured_media.id !== media.id) {
        changed = true;
      } else if (!previousVariant.featured_media && media) {
        changed = true;
      }

      if (!changed || !media) return;

      var slides = gallery.querySelectorAll('.product-gallery__media');
      var targetSlide = slides[media.position - 1];
      if (!targetSlide) return;

      var currentSlide = tiles.closest('.product-gallery__media');
      if (currentSlide === targetSlide) return;

      if (currentSlide) {
        currentSlide.classList.remove('up2-pdp-hero-slide');
      }
      targetSlide.classList.add('up2-pdp-hero-slide');
      targetSlide.appendChild(tiles);
    });
  }

  document.querySelectorAll('product-gallery').forEach(initGalleryTiles);
})();
